import * as types from "./action-types";
import initialState from "./state";
import { emptyArray } from "../constants";

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SUGGESTIONS_SUCCEEDED:
      return {
        ...state,
        isRouteSearching: false,
        suggestions: action.suggestions
      };
    case types.CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: []
      };
    case types.TOGGLE_LEGEND_POPUP:
      return {
        ...state,
        showLegendPopup: action.isOpen
      };
    case types.CHANGE_ROUTE:
    case types.SHOW_RESULTS:
      return {
        ...state,
        showResults: action.show
      };
    case types.SAVE_PLATON_RATE:
      return {
        ...state,
        platonRate: action.platonRate
      };
    case types.ROUTE_NOT_FOUND:
      return {
        ...state,
        isRouteSearching: false,
        routeNotFound: action.routeNotFound
      };
    case types.ROUTE_WITHOUT_RESTRICTIONS:
      return {
        ...state,
        isRouteSearching: false,
        routeWithoutRestrictions: action.routeWithoutRestrictions
      };
    case types.SET_ROUTE_SEARCH_PARAMS:
      return {
        ...state,
        restrictions: {
          ...state.restrictions,
          ...action.params.restrictions
        },
        calculations: {
          ...state.calculations,
          ...action.params.calculations
        }
      };
    case types.SEARCH_ROUTE_STARTED:
      return {
        ...state,
        isRouteSearching: true,
        isRouteSearchFailed: false
      };
    case types.SEARCH_ROUTE_SUCCEEDED:
      let newState = {
        ...state,
        isWelcomeScreen: false,
        isRouteSearching: false,
        routeNotFound: initialState.routeNotFound
      };
      if(action.route.routeInfo) {
        newState.routeInfo = action.route.routeInfo;
      }
      if(action.route.visualRoute) {
        newState.visualRoute = action.route.visualRoute;
      }
      if(action.route.debugInfo) {
        newState.debugInfo = action.route.debugInfo;
      }
      return newState;
    case types.SEARCH_ROUTE_FAILED:
      return {
        ...state,
        searchRouteError: action.searchRouteError,
        isRouteSearching: false,
        isRouteSearchFailed: true
      };
    case types.TOGGLE_SHOW_PASSING_CITIES:
      return {
        ...state,
        showPassingCitiesInRouteDetails: action.showPassingCitiesInRouteDetails
      };
    case types.FETCH_COMMON_STATS_SUCCEEDED:
      return {
        ...state,
        commonStats: {
          loads: action.stats.active_loads,
          trucks: action.stats.active_trucks,
          members: action.stats.active_firms
        }
      };
    case types.ADD_EXCLUDED_CITY:
      return {
        ...state,
        excludedCities:
          state.excludedCities.map(city => city.id).indexOf(action.city.id) === -1
            ? [...state.excludedCities, action.city]
            : [...state.excludedCities]
      };
    case types.ADD_EXCLUDED_COUNTRY:
      return {
        ...state,
        excludedCountries:
          state.excludedCountries.map(country => country.id).indexOf(action.country.id) === -1
            ? [...state.excludedCountries, action.country]
            : [...state.excludedCountries]
      };
    case types.REMOVE_EXCLUDED_CITY:
      return {
        ...state,
        excludedCities:
          state.excludedCities.length === 1
            ? emptyArray
            : [...state.excludedCities.filter(city => city.id !== action.id)]
      };
    case types.REMOVE_EXCLUDED_COUNTRY:
      return {
        ...state,
        excludedCountries:
          state.excludedCountries.length === 1
            ? emptyArray
            : [...state.excludedCountries.filter(country => country.id !== action.id)]
      };
    case types.RESET_ALL_EXCLUDED:
      return {
        ...state,
        excludedCities: emptyArray,
        excludedCountries: emptyArray
      };
    case types.UPDATE_ROUTE_REQUEST:
      return {
        ...state,
        /** @type {RouteRequest} */
        routeRequest: action.routeRequest
      };
    case types.SET_RESTRICTION_INITIAL_VALUE:
      return {
        ...state,
        restrictions: {
          ...state.restrictions,
          [action.payload.name]: action.payload.value
        }
      };
    case types.UPDATE_EXCLUDED_CITIES:
      return {
        ...state,
        excludedCities: action.payload
      };
    case types.UPDATE_EXCLUDED_COUNTRIES:
      return {
        ...state,
        excludedCountries: action.payload
      };
    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarToggled: !state.sidebarToggled
      };
    case types.HIDE_ERROR_NOTIFICATION:
      return {
        ...state,
        isRouteSearchFailed: false
      };
    case types.SET_APP_INITIALIZED:
      return {
        ...state,
        isInitialized: true
      };
    case types.INC_PENDING_REQUESTS:
      return {
        ...state,
        pendingRequests: state.pendingRequests + 1
      };
    case types.DEC_PENDING_REQUESTS:
      return {
        ...state,
        pendingRequests: state.pendingRequests - 1
      };
    case types.SET_SHOW_LIGHT_VERSION:
      return {
        ...state,
        showLightVersion: action.showLightVersion
      };
    case types.CALCULATE_ROUTE_METRICS:
      return {
        ...state,
        metrics: {
          ...action.metrics
        }
      };
    case types.SET_USER_PROFILE:
      return {
        ...state,
        profile: action.profile,
        isPaidUser: action.isPaidUser,
      };
    default:
      return state;
  }
};
